/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <!-- <v-card id="map_card">
    <div class="pb-10">
      <v-toolbar height="50px" class="sub-header">
        <v-toolbar-title class="body-2">String Monitoring</v-toolbar-title>
      </v-toolbar>  
    </div>
    <v-container  class="text-xs-center">
        <v-btn color="primary"  v-if="scb" @click="$router.push('/scb')" > <v-icon>router </v-icon> SCB</v-btn>
        <v-btn color="primary"  v-if="string" @click="$router.push('/stringInverter')" ><v-icon>router </v-icon> String Inverter</v-btn>
        <v-btn color="primary"  v-if="advancedString" @click="$router.push('/advancedStringInverter')" ><v-icon>router </v-icon> Advanced String Inverter</v-btn>
        <v-btn color="primary"  v-if="zone" @click="$router.push('/zone')" ><v-icon>router </v-icon> Zone Monitoring</v-btn>
       
    </v-container>
  </v-card> -->
  

  <div>
    <v-container fluid grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs4 v-if="scb">
          <div class="ana-card" @click="$router.push('/scb')">
            <div class="text-xs-center">
              <div class="name-icon">S</div>
            </div>
            <div class="ana-card-text">SCB</div>
          </div>
        </v-flex>
        <v-flex xs4 v-if="string">
          <div class="ana-card" @click="$router.push('/stringInverter')">
            <div class="text-xs-center">
              <div class="name-icon">SI</div>
            </div>
            <div class="ana-card-text">String Inverter</div>
          </div>
        </v-flex>
        <v-flex xs4 v-if="zone">
          <div class="ana-card" @click="$router.push('/zone')">
            <div class="text-xs-center">
              <div class="name-icon">ZM</div>
            </div>
            <div class="ana-card-text">Zone Monitoring</div>
          </div>
        </v-flex>
        <v-flex xs4 v-if="advancedString">
          <div class="ana-card" @click="$router.push('/advancedStringInverter')">
            <div class="text-xs-center">
              <div class="name-icon">SI</div>
            </div>
            <div class="ana-card-text">Advanced String Inverter</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>


</template>

<script>
import scbPages from './../../services/StringMonitoring.js'
import { EventBus } from "@/services/event-bus"
import { mapGetters } from 'vuex'
const moment = require('moment')

export default {
  computed: {
    ...mapGetters(["getSelectedPlantId"])
  },
  data() {
    return {
      dataSet: [],
      scb: false,
      string: false,
      zone: false,
      advancedString: false
    }
  },
  mounted() {
    this.getPages();
    //listening to all the global events
    EventBus.$on("plantChanged", this.getPages);
  },
  methods: {


    async getPages() {
      this.scb = false;
      this.string = false;
      this.zone = false;
      this.advancedString = false;
      let response = await scbPages.getAllScbPages(this.getSelectedPlantId)
      if (response.status === 200) {
        let parameters = response.data.message
        let parameterList = parameters.toLowerCase().split(',');
        for (var i = 0; i < parameterList.length; i++) {
          if (parameterList[i].toLowerCase() == 'scb') {
            this.scb = true;
          } else if (parameterList[i].toLowerCase() == 'string') {
            this.string = true;
          } else if (parameterList[i].toLowerCase() == 'zone') {
            this.zone = true;
          } else if (parameterList[i].toLowerCase() == 'advancedstring') {
            this.advancedString = true;
          }
        }
      }
    }
  },
  beforeDestroy() {
    EventBus.$off("plantChanged", this.getPages);
  },
  watch: {
    plantChange() {
      this.getPages();
    }
  }
}
</script>
<style scoped>
.ana-card{
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
}

.ana-card-text{
  font-size: 18px;
  font-weight: 500;
}
.name-icon{
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 26px;
  display: inline-block;
  line-height: 50px;
}
</style>

